import { useEffect, useState, useCallback } from 'react';
import { getPracticePoolBudget } from 'api/marketing';
import { getGPAdPoolBudget } from 'api/operation/group';
import { IPracticePoolBudget } from 'types/marketing';

// isOps + organizationId route to the OPS org-scoped endpoint; without them it stays provider-scoped.
const usePracticePoolBudget = (
    isOps = false,
    organizationId?: number,
): [IPracticePoolBudget | undefined, boolean, () => void] => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<IPracticePoolBudget>();

    const fetchData = useCallback(async () => {
        if (isOps && !organizationId) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const result = isOps ? await getGPAdPoolBudget(organizationId!) : await getPracticePoolBudget();
            if (!result.error && result?.data?.data) {
                setData(result.data.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, [isOps, organizationId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default usePracticePoolBudget;
